import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Linkedin, Facebook, Instagram } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const serviciosLinks = [
    { name: 'CFO Externo', href: '/servicios' },
    { name: 'Consultoría Financiera', href: '/servicios' },
    { name: 'Centro de Servicios Contables', href: '/servicios' }
  ];

  const empresaLinks = [
    { name: 'Quiénes Somos', href: '/quienes-somos' },
    { name: 'Nuestros Valores', href: '/quienes-somos' },
    { name: 'Contacto', href: '/contacto' }
  ];

  const legalLinks = [
    { name: 'Política de Privacidad', href: '/politica-privacidad' }
  ];

  return (
    <footer className="bg-sinergia-gris-oscuro text-white">
      {/* Main Footer Content */}
      <div className="container mx-auto px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <div className="mb-4">
              <img 
                src="/logotipo_blanco_sinergia.png" 
                alt="Sinergia Empresarial"
                className="h-16 w-auto"
              />
            </div>
            <p className="body-small text-sinergia-gris-claro mb-4">
              Estrategia financiera y operación contable para que tu empresa crezca con control.
            </p>
            <div className="space-y-2">
              <a 
                href="mailto:contacto@sinergiaempresarialcsce.com" 
                className="flex items-center text-sinergia-gris-claro hover:text-white transition-colors body-small"
              >
                <Mail className="w-4 h-4 mr-2" />
                contacto@sinergiaempresarialcsce.com
              </a>
              <a 
                href="tel:+573175111422" 
                className="flex items-center text-sinergia-gris-claro hover:text-white transition-colors body-small"
              >
                <Phone className="w-4 h-4 mr-2" />
                +57 317 511 1422
              </a>
              <div className="flex items-center text-sinergia-gris-claro body-small">
                <MapPin className="w-4 h-4 mr-2" />
                Colombia
              </div>
            </div>
          </div>

          {/* Servicios */}
          <div>
            <h4 className="heading-5 font-semibold mb-4 font-montserrat">Servicios</h4>
            <ul className="space-y-2">
              {serviciosLinks.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.href}
                    className="body-small text-sinergia-gris-claro hover:text-white transition-colors"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
              <li>
                <Link
                  to="/paquetes-precios"
                  className="body-small text-sinergia-gris-claro hover:text-white transition-colors font-semibold"
                >
                  Ver todos los paquetes →
                </Link>
              </li>
            </ul>
          </div>

          {/* Empresa */}
          <div>
            <h4 className="heading-5 font-semibold mb-4 font-montserrat">Empresa</h4>
            <ul className="space-y-2">
              {empresaLinks.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.href}
                    className="body-small text-sinergia-gris-claro hover:text-white transition-colors"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal & Social */}
          <div>
            <h4 className="heading-5 font-semibold mb-4 font-montserrat">Legal</h4>
            <ul className="space-y-2 mb-6">
              {legalLinks.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.href}
                    className="body-small text-sinergia-gris-claro hover:text-white transition-colors"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>

            <h4 className="heading-5 font-semibold mb-4 font-montserrat">Síguenos</h4>
            <div className="flex space-x-4">
              <a
                href="#"
                className="w-10 h-10 bg-sinergia-azul rounded-full flex items-center justify-center hover:bg-sinergia-verde-claro transition-colors"
                aria-label="LinkedIn"
              >
                <Linkedin className="w-5 h-5" />
              </a>
              <a
                href="#"
                className="w-10 h-10 bg-sinergia-azul rounded-full flex items-center justify-center hover:bg-sinergia-verde-claro transition-colors"
                aria-label="Facebook"
              >
                <Facebook className="w-5 h-5" />
              </a>
              <a
                href="#"
                className="w-10 h-10 bg-sinergia-azul rounded-full flex items-center justify-center hover:bg-sinergia-verde-claro transition-colors"
                aria-label="Instagram"
              >
                <Instagram className="w-5 h-5" />
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-sinergia-gris-claro border-opacity-30">
        <div className="container mx-auto px-6 py-6">
          <div className="flex flex-col md:flex-row items-center justify-between">
            <p className="body-small text-sinergia-gris-claro text-center md:text-left">
              © {currentYear} Sinergia Empresarial CSCE S.A.S. Todos los derechos reservados.
            </p>
            <p className="body-small text-sinergia-gris-claro mt-2 md:mt-0">
              Diseñado para el crecimiento de las PYMEs colombianas
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
